<template>
    <div v-if="bizAuth.editContractPolicy.hasRight" class="page-setting has-bc parent-frame batch-policy" :class="{'fixed': listIsFixed}">
        <modal class="delete" :display="modalStatus.delete" @modalStatus="closeModal" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>清空政策</h1>
            <div class="content">
                確定清空您所選的政策嗎？<br>確認清空後將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deletePolicy(), $analyticsBiz.logEvent('清空全部', { screen_name: '清空全部'})">確認清空</button>
            </div>
        </modal>
        <add-policy-to-now></add-policy-to-now>
        <all-instead-policy></all-instead-policy>
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}({{batchListTotal}})</h1>
            <div class="btn-group" v-if="hasSeletedHouse">
                <div class="border-button publish" @click="modalStatus.delete = true">
                    清空政策
                </div>
                <div class="border-button publish" @click="insteadPolicy">
                    全部替換為
                </div>
                <div class="default-button publish" @click="addToNowPolicy">
                    添加到現有
                </div>
            </div>
        </div>
        <batch-policy></batch-policy>
    </div>
</template>
<script>
import batchPolicy from '@/components/bussiness/mgtCategory/houseMgt/batchPolicy/batchPolicyComp.vue';
import addPolicyToNow from '@/components/bussiness/widges/modals/addPolicyToNow.vue';
import allInsteadPolicy from '@/components/bussiness/widges/modals/allInsteadPolicy.vue';
import Modal from '@/components/widge/Modal.vue';

import { mapGetters } from 'vuex'


export default {
    data () {
        return {
            listIsFixed: false,
            modalStatus:{
                delete: false,
            },
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
        this.$store.dispatch('getBizLandlordPolicyList')
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.editContractPolicy.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
        addToNowPolicy: function () {
            this.$analyticsBiz.logEvent('添加到現有', { screen_name: '添加到現有'})
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizAddPolicyToNow'})
        },
        deletePolicy: function () {
            this.$store.dispatch('deleteBizBatchPolicy')
            .then(()=>{
                this.closeModal()
                this.$store.dispatch('setAlarmStatus', {status: true,title: '成功清空政策',type: 'success'})
            })
        },
        insteadPolicy: function () {
            this.$analyticsBiz.logEvent('全部替換為', { screen_name: '全部替換為'})
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizAllInsteadPolicy'})
        },
        closeModal: function () {
            this.modalStatus.delete = false
        }
    },
    computed: {
        ...mapGetters({
            hasSeletedHouse: 'GET_BIZ_BATCH_POLICY_HAS_SELECTED_HOUSE',
            batchListTotal: 'GET_BIZ_BATCH_POLICY_LIST_TOTAL',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        batchPolicy,
        addPolicyToNow,
        allInsteadPolicy,
        Modal
    }
}
</script>
<style lang="scss">
    .batch-policy{
        #modal.delete{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                }
            }
        }
        &.page-setting.fixed .table-list .table-list-title {
            width: 819px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/houseMgt/batchPolicy.vue